import { Model } from 'vue-api-query';
import { Context } from '@nuxt/types';

export default function vueApiQuery(context: Context) {
  Model.$http = context.$axios;
}
